module.exports = __webpack_public_path__ + "static/media/icon.319fe1d7.png";